import React from 'react';
import styled from "styled-components";

const SliderField = ({value, units, placeholder, min, max, step, onChange}) => {

    const handleChange = (value, partial) => {
        onChange?.(value, partial);
    };

    return (
        <SliderDiv>
            <input
                className={'slide-bar'}
                type="range"
                min={min}
                max={max}
                step={step}
                value={value}
                onChange={(event) => {
                    handleChange(event.target.value)
                }}
                style={{flex: 1}}
            />
        </SliderDiv>
    );
};

const SliderDiv = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 5px;

    input[type="range"] {
        -webkit-appearance: none; /* 기본 스타일 제거 */
        width: 100%;
        height: 6px;
        background: #ddd;
        border-radius: 3px;
        outline: none;
        margin: 5px 0;
    }

    /* 바(트랙) 색상 */

    input[type="range"]::-webkit-slider-runnable-track {
        height: 6px;
        background: #8b5cf6; /* 바 색상 */
        border-radius: 3px;
    }

    /* 손잡이(슬라이더 핸들) 스타일 */

    input[type="range"]::-webkit-slider-thumb {
        -webkit-appearance: none;
        width: 16px;
        height: 16px;
        background: #ffffff;
        border: 2px solid #8b5cf6;
        border-radius: 50%;
        margin-top: -5px; /* thumb를 중앙 정렬 */
        cursor: pointer;
    }

    /* Firefox */

    input[type="range"]::-moz-range-track {
        height: 6px;
        background: #8b5cf6;
        border-radius: 3px;
    }

    input[type="range"]::-moz-range-thumb {
        width: 16px;
        height: 16px;
        background: #ffffff;
        border: 2px solid #8b5cf6;
        border-radius: 50%;
        cursor: pointer;
    }
`;


export default SliderField;